import { Node, mergeAttributes } from "@tiptap/core";

export interface YouTubeVideoAttributes {
  url: string | null;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    youtubeVideo: {
      setYouTubeVideo: (options: Partial<YouTubeVideoAttributes>) => ReturnType;
    };
  }
}

export const YouTubeVideoNode = Node.create({
  name: "youtubeVideo",
  group: "block",
  inline: false,
  draggable: true,
  selectable: true,
  atom: true,

  addAttributes() {
    return {
      url: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-url"),
        renderHTML: (attributes) => ({ "data-url": attributes.url }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'div[data-type="youtubeVideo"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const url = HTMLAttributes["data-url"] || HTMLAttributes.url;

    // Server-side rendering: create a simple placeholder with link
    if (url) {
      return [
        "div",
        mergeAttributes(HTMLAttributes, {
          "data-type": "youtubeVideo",
          class: "youtube-video-placeholder",
        }),
        [
          "p",
          {},
          [
            "a",
            {
              href: url,
              target: "_blank",
              rel: "noopener noreferrer",
            },
            `YouTube Video: ${url}`,
          ],
        ],
      ];
    }

    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "youtubeVideo",
        class: "youtube-video-placeholder",
      }),
      "YouTube Video (no URL provided)",
    ];
  },

  addCommands() {
    return {
      setYouTubeVideo:
        (options: Partial<YouTubeVideoAttributes>) =>
        ({ chain }) => {
          return chain()
            .insertContent({
              type: this.name,
              attrs: options,
            })
            .run();
        },
    };
  },
});
